module.exports = __webpack_public_path__ + "static/media/pdf.efd44f49.png";